import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from "../layout/element/button.component";

@Component({
  selector: 'msh-focused-form',
  imports: [ButtonComponent],
  template: `
<div class="w-auto md:w-96 mx-auto mt-12 mb-12 p-6 bg-back rounded shadow-lg border border-navy-50">
  <div class="text-navy-600 text-xl font-semibold mb-4 text-center" ><ng-content select="[heading]"></ng-content></div>
  <div>
    <ng-content></ng-content>
    @if(!hideSubmitButton){
      <msh-button (onClick)="onSubmitClick($event)" [isLoading]="isLoading" [disabled]="disabled" type="submit" [cta]="cta"></msh-button>
    }
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
  `,
  styles: ``
})
export class FocusedFormComponent {
  @Input() cta: string = "submit";
  @Input() disabled: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() hideSubmitButton: boolean = false;
  @Output() onSubmit: EventEmitter<Event> = new EventEmitter<Event>();
  onSubmitClick(ev: Event){
    console.log({ev})
    this.onSubmit.emit(ev);
  }
}
